import { render } from "./ChatTool.vue?vue&type=template&id=4eee22f8&scoped=true"
import script from "./ChatTool.vue?vue&type=script&lang=js"
export * from "./ChatTool.vue?vue&type=script&lang=js"

import "./ChatTool.vue?vue&type=style&index=0&id=4eee22f8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eee22f8"]])

export default __exports__